import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GlobalErrorState } from './global-error.reducer';

export const selectGlobalErrorState = createFeatureSelector<GlobalErrorState>('globalError');

export const selectGlobalError = createSelector(selectGlobalErrorState, (s) => s.entity);
